import { ProductPage, PageHead , SeoFooter} from '@/components'

const Product = ({ product }) => {
    return (
        <>
            <PageHead meta={product.seo_meta}/>
            <ProductPage product={product} />
            {product.seo_meta.addtional_description && <SeoFooter text={product.seo_meta.addtional_description}/>}
        </>
    )
}

Product.getInitialProps = async ({ api, query, res, city }) => {
    if (city.slug === query.slug) {
        if (city.is_default) {
            //если город дэфолтный и он совпадает с выбранным
            if (res) {
                res.writeHead(302, {
                    Location: `/${query.productSlug}`,
                })
                res.end()
            } else {
                Router.push('/[slug]', `/${query.productSlug}`)
            }
            return
        }
    }

    const product = await api.page({ slug: query.productSlug, city: query.slug })

    return { product: product.data }
}

export default Product
